import { t } from 'i18next'
import * as z from 'zod'

import type { UpsertFavoriteListFormVO } from './type'

import type { InputOption } from '@/types'

const MAX_LENGTH = {
  name: 50,
  salesTypeCodes: 10,
}

export const schema = z.object({
  name: z
    .string()
    .min(1, { message: t('favorite.list.validation.required') })
    .max(MAX_LENGTH.name, {
      message: t('favorite.list.validation.max_length', {
        max: MAX_LENGTH.name,
      }),
    }),
  isShared: z.boolean(),
  salesTypeCodes: z
    .array(z.string())
    .min(1, { message: t('favorite.list.validation.required') })
    .max(MAX_LENGTH.salesTypeCodes, {
      message: t('favorite.list.sales_type.max', {
        max: MAX_LENGTH.salesTypeCodes,
      }),
    }),
})

export const formLabels: Record<keyof UpsertFavoriteListFormVO, string> = {
  name: t('favorite.list.name'),
  isShared: t('favorite.list.shared'),
  salesTypeCodes: t('favorite.list.sales_type.title'),
}

export const DEFAULT_SELECTED_SALES_TYPE = '1'

export const formDefaultValues: Partial<UpsertFavoriteListFormVO> = {
  name: undefined,
  isShared: false,
  salesTypeCodes: ['1', '2'],
}

export const isSharedOptions: InputOption<boolean>[] = [
  {
    value: true,
    label: '共有する',
  },
  {
    value: false,
    label: '共有しない',
  },
]
